import data from "./CustomersData";
import { mapState } from "vuex";
import moment from "moment";
import jexcel from "jexcel";

export default {
  ...data,
  props: {
    reportDates: Array,
    selectedBranch: Array,
    selectedDatasets: Array,
    selectedAreas: Array,
    selectedCustCat: Array,
  },
  computed: {
    ...mapState("userProfileVuex", [
      "username",
      "useremail",
      "userImage",
      "datasets",
      "areas",
      "custgroups",
      "nkagroups",
      "custs",
      "prods",
      "branches",
      "roles",
    ]),
    reportDatesArray() {
      let startNextMonth = moment(this.reportDates[0])
        .add(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");

      let datesArray = [startNextMonth];
      for (let i = 0; i < 12; i++) {
        datesArray.push(
          moment(this.reportDates[0])
            .subtract(i, "month")
            .startOf("month")
            .format("YYYY-MM-DD")
        );
      }
      return datesArray;
    },
  },
  methods: {
    getCustData() {
      let casewhen = "";

      for (let i = 0; i < this.reportDatesArray.length - 1; i++) {
        casewhen += `CASE WHEN docdate <"${
          this.reportDatesArray[i]
        }" AND docdate >="${
          this.reportDatesArray[i + 1]
        }" THEN sum(mt) ELSE 0 END AS mt${i}, `;
      }

      let querydataset = "";
      this.selectedDatasets.forEach((item, index) => {
        if (index < this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} UNION ALL `;
        } else if (index === this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} `;
        }
      });

      let areas = "";
      if (this.selectedAreas.length === 0) {
        areas = this.areas;
      } else {
        areas = " AND area IN (";
        this.selectedAreas.forEach((i, index) => {
          if (index < this.selectedAreas.length - 1) {
            areas += `"${i}",`;
          } else {
            areas += `"${i}")`;
          }
        });
      }

      let custgroup = "";
      if (this.selectedCustCat.length !== 0) {
        custgroup = " AND custgroupcat IN (";
        this.selectedCustCat.forEach((i, index) => {
          if (index < this.selectedCustCat.length - 1) {
            custgroup += `"${i}",`;
          } else {
            custgroup += `"${i}")`;
          }
        });
      }

      gapi.client.load("bigquery", "v2").then(() => {
        let sqlquery = `

        WITH querydataset AS (
          ${querydataset}
        )
        
        SELECT custno, custname, area, custcat,
        SUM(mt0) AS mt0, SUM(mt1) AS mt1,SUM(mt2) AS mt2,SUM(mt3) AS mt3,SUM(mt4) AS mt4,SUM(mt5) AS mt5,
        SUM(mt6) AS mt6,SUM(mt7) AS mt7,SUM(mt8) AS mt8,SUM(mt9) AS mt,SUM(mt10) AS mt10,SUM(mt11) AS mt11
        FROM
        (SELECT custno, custname,area,
        CASE WHEN custgroupcat IS NULL THEN "Uncategorised" ELSE custgroupcat END AS custcat,
        ${casewhen}
        FROM querydataset
        WHERE docdate <"${this.reportDatesArray[0]}" AND docdate >="${this.reportDatesArray[12]}"
        ${areas}
        ${custgroup}
        ${this.custgroups}
        ${this.nkagroups}
        GROUP BY custno, custname, area, custgroupcat, docdate)
        GROUP BY area,custno, custname, custcat
        ORDER BY area
        `;

        let request = gapi.client.bigquery.jobs.query({
          projectId: "1082735422951",
          timeoutMs: "50000",
          query: sqlquery,
          useLegacySql: false,
        });

        request.execute((response) => {
          this.prepSpreadsheetData(response.rows);
        });
      });
    },
    prepSpreadsheetData(data) {
      let tempdata = [];

      data.forEach((item) => {
        let itemdata = [];
        itemdata = [item.f[0].v];
        for (let i = 1; i < item.f.length; i++) {
          itemdata.push(item.f[i].v);
        }
        tempdata.push(itemdata);
      });

      this.customerData = tempdata;

      tempdata.forEach((item) => {
        let areaIndex = this.areasList.findIndex((i) => i === item[2]);
        if (areaIndex === -1) {
          this.areasList.push(item[2]);
        }
      });

      this.filterSpreadsheetdata();
    },
    filterSpreadsheetdata() {
      let tempdata = [];

      if (this.selectedReport === "No Orders (6 months)") {
        tempdata = this.customerData.filter(
          (i) =>
            parseFloat(i[4]) === 0 &&
            parseFloat(i[5]) === 0 &&
            parseFloat(i[6]) === 0 &&
            parseFloat(i[7]) === 0 &&
            parseFloat(i[8]) === 0 &&
            parseFloat(i[9]) === 0
        );
      } else if (this.selectedReport === "No Orders (3 months)") {
        tempdata = this.customerData.filter(
          (i) =>
            parseFloat(i[4]) === 0 &&
            parseFloat(i[5]) === 0 &&
            parseFloat(i[6]) === 0
        );
      } else if (this.selectedReport === "No Orders (2 months)") {
        tempdata = this.customerData.filter(
          (i) => parseFloat(i[4]) === 0 && parseFloat(i[5]) === 0
        );
      } else if (this.selectedReport === "All") {
        tempdata = this.customerData;
      } else if (this.selectedReport === "No Orders (Current Month)") {
        tempdata = this.customerData.filter(
          (i) => parseFloat(i[4]) === 0 && parseFloat(i[5]) !== 0
        );
      }
      if (this.selectedArea !== "All") {
        tempdata = tempdata.filter((i) => i[2] === this.selectedArea);
      }

      this.totalCustomers = tempdata.length;

      document.getElementById("my-spreadsheet2").innerHTML = "";

      this.renderSpreadsheet(tempdata);
    },
    renderSpreadsheet(sheetdata) {
      let headers = [];
      headers = [
        {
          title: "Cust. No.",
          width: 80,
          align: "left",
        },
        { title: "Cust. Name", width: 300, align: "left" },
        { title: "Area", width: 50, align: "left" },
        { title: "Category", width: 100, align: "left" },
      ];

      for (let i = 1; i < this.reportDatesArray.length; i++) {
        headers.push({
          title: moment(this.reportDatesArray[i]).format("MMM YY"),
          width: 80,
          align: "right",
        });
      }
      let table1 = jexcel(document.getElementById("my-spreadsheet2"), {
        data: sheetdata,
        columns: headers,
        //tableOverflow: true,
        //lazyLoading: true,
        //loadingSpin: true,
        tableHeight: "600px",
      });
    },
  },
  mounted() {
    this.getCustData();
  },
};
